import { ChangeEvent, DataSourceExecutionEvent, OpenType } from "@mcleod/components";
import { AutogenLayoutCarrierSalesDetail } from "@mcleod/crm/src/autogen/AutogenLayoutCarrierSalesDetail";
import { LanePreferenceContactManager } from "@mcleod/dispatch";
import { StringUtil } from "@mcleod/core";

export class CarrierSalesDetail extends AutogenLayoutCarrierSalesDetail {
    private contactManager: LanePreferenceContactManager;
    private _carrierId: string;

    onLoad(): void | Promise<void> {
        this.layoutTableContact.tableContacts.maxHeight = null;
        this.layoutManageCarrierCapacity.buttonAvailableTractors.enabled = false;
        this.layoutManageCarrierCapacity.buttonCarrierCapacity.enabled = false;
        this.layoutCarrierOfferList.tableOffers.defaultOpenType = OpenType.NEW_TAB_WITH_SWITCH;
        this.layoutTableComment.displayCopyOrderFields = false;
        this.layoutTableComment.displayDispatchField = true;
    }

    switchLanePreferenceDisplayOnChange(event: ChangeEvent) {
        this.layoutLaneSendToContacts.visible = !event.newValue;
        this.layoutLanePreferenceTable.visible = event.newValue;
        this.contactManager.syncLaneContactsAndPreferences();
    }

    sourceCarrierAfterExecution(event: DataSourceExecutionEvent) {
        if (this.sourceCarrier.activeRow != null) {
            const carrierId = this.activeRow.get('id');
            this.layoutManageCarrierCapacity.carrierId = carrierId;
            this.layoutManageCarrierCapacity.mainDataSource.search({"carrier_id": this.activeRow.get("id"), "only_active": true});
            this.layoutLanePreferenceTable.payeeId = carrierId;
            this.layoutLaneSendToContacts.payeeId = carrierId;
            this.layoutCarrierOfferList.carrierName = this.activeRow.get("payee.name");
            this.layoutCarrierOfferList.textboxCarrierName.enabled = false;
            this.layoutCarrierOfferList.buttonViewInNewTab.visible = true;
            this.syncPnnOptions(this.activeRow.getBoolean("pnn_carrier.is_active", false));
            this.contactManager = new LanePreferenceContactManager({
                lanePreferenceTable: this.layoutLanePreferenceTable.tableLanes,
                sendToContactsTable: this.layoutLaneSendToContacts.tableSendToContacts,
                carrierContactsTable: this.layoutTableContact.tableContacts,
                parentDataSource: this.mainDataSource
            });
        }
    }

    switchActivePNNCarrierOnChange(event: ChangeEvent) {
        this.syncPnnOptions(event.newValue);
    }

    syncPnnOptions(isActive: boolean) {
        this.panelPnnOptions.visible = this.panelPnnComments.visible = isActive;
        this.switchActivePNNCarrier.paddingTop = isActive ? 0 : 13;
    }

    public get carrierId(): string {
        return this._carrierId;
    }
    public set carrierId(value: string) {
        this._carrierId = value;
        const validCarrier = !StringUtil.isEmptyString(value);

        if (validCarrier) {
            this.mainDataSource.search({ id: value }, null, "lme/dispatch/Carrier").then(() => {
                this.layoutCarrierActionList.carrierId = value;
            });
        }
    }
}
